/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidacyShowPathParams, CandidacyShowResponse } from '../types/CandidacyShow'

/**
 * GET /candidate-center/organisations/:organisation/candidacies/:candidacy
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidacyController.php CandidacyController::show
 */
export async function candidacyShow(
	organisation: CandidacyShowPathParams['organisation'],
	candidacy: CandidacyShowPathParams['candidacy'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidacyShowResponse>> {
	return axiosInstance.get(`/candidate-center/organisations/${organisation}/candidacies/${candidacy}`, config)
}
